import { useState } from 'react';
import { registerUsername } from '../api/client';
import { Player } from '../types';

interface Props {
  onDone: (player: Player) => void;
}

export default function UsernameScreen({ onDone }: Props) {
  const [username, setUsername] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const valid = /^[a-zA-Z0-9_]{3,20}$/.test(username);

  async function submit() {
    if (!valid || loading) return;
    setLoading(true);
    setError(null);
    try {
      const res = await registerUsername(username);
      onDone(res);
    } catch (e: any) {
      setError(e.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="screen">
      <div className="arcade-title">TARGET RUSH<br />GLOBAL ARENA</div>
      <div className="panel" style={{ width: 360 }}>
        <div className="input-row">
          <label className="arcade-subtitle">Choose your callsign</label>
          <input
            className="text-input"
            value={username}
            maxLength={20}
            placeholder="e.g. DustDevil47"
            onChange={(e) => setUsername(e.target.value.replace(/\s/g, ''))}
            onKeyDown={(e) => e.key === 'Enter' && submit()}
            autoFocus
          />
          <span className="hint">3-20 characters. Letters, numbers, underscores. Must be globally unique.</span>
          {error && <span className="error-text">{error}</span>}
        </div>
        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center' }}>
          <button className="arcade-btn" disabled={!valid || loading} onClick={submit}>
            {loading ? 'Checking...' : 'Enter the Arena'}
          </button>
        </div>
      </div>
    </div>
  );
}
